import React from "react";

/**
 * LogoSpinner Component
 *
 * A loading spinner using the Cluck.us logo symbol
 * Provides a branded loading experience
 */
const LogoSpinner = ({
  size = "medium",
  className = "",
  text = "Loading...",
}) => {
  const sizeClasses = {
    small: "w-8 h-8",
    medium: "w-12 h-12",
    large: "w-16 h-16",
    xlarge: "w-24 h-24",
  };

  return (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <div className={`${sizeClasses[size]} mb-4 animate-spin`}>
        <img
          src="/Logo-symbol-1.svg"
          alt="Cluck.us Logo"
          className="w-full h-full"
          onError={(e) => {
            // Fallback to a simple spinner if logo fails to load
            e.target.style.display = "none";
            e.target.parentElement.innerHTML =
              '<div class="w-full h-full border-4 border-primary border-t-transparent rounded-full animate-spin"></div>';
          }}
        />
      </div>
      {text && <p className="text-foreground text-sm font-medium">{text}</p>}
    </div>
  );
};

export default LogoSpinner;
